export default __webpack_public_path__ + "static/media/MarkusLuepertz1001.b53f803f.jpg";